function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M17.4,11c0-0.3,0.1-0.6,0.1-1s0-0.7-0.1-1l2.1-1.7c0.2-0.2,0.2-0.4,0.1-0.6l-2-3.5 C17.6,3.1,17.4,3,17.2,3c-0.1,0-0.1,0-0.2,0l-2.5,1c-0.5-0.4-1.1-0.7-1.7-1l-0.4-2.7C12.5,0.2,12.3,0,12,0H8C7.8,0,7.5,0.2,7.5,0.4 L7.1,3.1C6.5,3.3,6,3.7,5.4,4L3,3C2.9,3,2.8,3,2.8,3C2.6,3,2.4,3.1,2.3,3.3l-2,3.5C0.2,6.9,0.3,7.2,0.5,7.4L2.6,9 c0,0.3-0.1,0.6-0.1,1s0,0.7,0.1,1l-2.1,1.7c-0.2,0.1-0.2,0.4-0.1,0.6l2,3.5C2.4,16.9,2.6,17,2.8,17c0.1,0,0.1,0,0.2,0l2.5-1 c0.5,0.4,1.1,0.7,1.7,1l0.4,2.6C7.5,19.8,7.8,20,8,20h4c0.2,0,0.5-0.2,0.5-0.4l0.4-2.6c0.6-0.2,1.2-0.6,1.7-1l2.5,1 c0.1,0,0.1,0,0.2,0c0.2,0,0.3-0.1,0.4-0.2l2-3.5c0.1-0.2,0.1-0.5-0.1-0.6L17.4,11z M15.5,9.3c0,0.3,0.1,0.5,0.1,0.7s0,0.4-0.1,0.7 l-0.1,1.1l0.9,0.7l1.1,0.8l-0.7,1.2l-1.3-0.5l-1-0.4l-0.9,0.7c-0.4,0.3-0.8,0.6-1.2,0.7l-1.1,0.4l-0.2,1.1L10.7,18H9.3l-0.2-1.4 L9,15.5l-1.1-0.4c-0.4-0.2-0.8-0.4-1.2-0.7l-0.9-0.7l-1.1,0.4l-1.3,0.5l-0.7-1.2l1.1-0.8l0.9-0.7l-0.1-1.1c0-0.3-0.1-0.5-0.1-0.7 s0-0.4,0.1-0.7l0.1-1.1L3.8,7.4L2.7,6.6l0.7-1.2l1.3,0.5l1,0.4l0.9-0.7c0.4-0.3,0.8-0.6,1.2-0.7l1.1-0.4l0.2-1.1L9.3,2h1.4l0.2,1.4 L11,4.5l1.1,0.4c0.4,0.2,0.8,0.4,1.2,0.7l0.9,0.7l1.1-0.4l1.3-0.5l0.7,1.2l-1.1,0.8l-0.9,0.7L15.5,9.3z M10,6c-2.2,0-4,1.8-4,4 s1.8,4,4,4s4-1.8,4-4S12.2,6,10,6z M10,12c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S11.1,12,10,12z"
});

var SvgGeneral = function SvgGeneral(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGeneral, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/general.ad2ad5a4.svg";
export { ForwardRef as ReactComponent };